// src/data/helpTopics.tsx
// Help Center topics. The title, slug and description live in helpTopics.json so the
// build scripts (sitemap, prerender) read exactly what this page serves (#1143);
// only the presentation is added here. `title` MUST exactly match the `topic` field
// stored on articles: that's how articles are grouped. The articles' own topicSlug
// field does NOT match these slugs, so never route by it.
import React from 'react';
import { Rocket, PenLine, Globe2, Share2, BookOpen, Layers } from 'lucide-react';
import topicData from './helpTopics.json';

export interface TopicMeta {
  title: string;   // must match ArticleListItem.topic exactly
  slug: string;    // route slug for /help/topic/:slug
  tone: string;    // '', 'green', or 'orange' (icon accent)
  desc: string;
  icon: React.ReactNode;
}

const LOOK: Record<string, { tone: string; icon: React.ReactNode }> = {
  'getting-started':     { tone: '',       icon: <Rocket size={22} /> },
  'writing-editor':      { tone: '',       icon: <PenLine size={22} /> },
  'world-building':      { tone: 'green',  icon: <Globe2 size={22} /> },
  'relationships':       { tone: 'green',  icon: <Share2 size={22} /> },
  'book-design-export':  { tone: 'orange', icon: <BookOpen size={22} /> },
  'series-sync-account': { tone: '',       icon: <Layers size={22} /> },
};

export const TOPICS: TopicMeta[] = topicData.map((t) => {
  const look = LOOK[t.slug];
  if (!look) throw new Error(`helpTopics.json has ${t.slug}, which has no icon in helpTopics.tsx`);
  return { ...t, ...look };
});

export const topicBySlug = (slug: string): TopicMeta | undefined =>
  TOPICS.find(t => t.slug === slug);

export const topicByTitle = (title: string): TopicMeta | undefined =>
  TOPICS.find(t => t.title === title);
